import React from 'react'
import { connect } from "react-redux";
import { SetReverseBankDefault, GetDepositMemberBanks } from '$Deposits/store/actions/DepositAction'
import { SetDepositPayments_BQR } from '$Deposits/store/actions/DepositPost'
import { GetParamsData, bankCodeWriting } from '$Deposits/lib/LibCommonData'




class RD extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
        };
    }

    componentDidMount() {

    }
    componentWillUnmount() {
        this.props.SetReverseBankDefault('')
    }

    render() {
        const { goAddBankInfo, LivechatClick, webPiwikEvent, webPiwikUrl} = GetParamsData() || {}
        const {
            DepositMemberBanks = [],
            AddBank,
            BindBank,
            SetReverseBankDefault,
            DepositMemberBanksActive,
            GetDepositMemberBanks,
            ReverseBankDefault,
            BankNone,
            MethodsDetails,
            Modal,
            BankActive,
            MemberInfo,
            BanksBankAccounts
        } = this.props

        const isShowCS = MemberInfo && MemberInfo.isSingleDeposit && DepositMemberBanks.length == 1? true: false
        const { setting } = MethodsDetails || {}
        const { result = {}, isSuccess,  } = ReverseBankDefault || {}
        let bindErr = ''
        let onlyOkBtn = true
        if(!isSuccess && result.errorCode) {
            if(result.errorCode == "P112001" || result.errorCode == "P112004" || result.errorCode == "P112005") {
                webPiwikUrl("express_deposit_error_popup", "Express Deposit Error Popup")
                //联系客服处理
                bindErr = `การผูกบัญชีล้มเหลว \n กรุณาติดต่อฝ่ายบริการเพื่อให้ความช่วยเหลือ`
                onlyOkBtn = false
            } else if(result.errorCode == "P112002") {
                webPiwikUrl("express_deposit_error_popup", "Express Deposit Error Popup")
                //已经绑定卡号了
                bindErr = 'บัญชีธนาคารที่คุณเพิ่ม มีการผูกบัญชีในระบบแล้ว'
            } else if(result.errorCode == "P112003") {
                webPiwikUrl("express_deposit_error_popup", "Express Deposit Error Popup")
                //其他会员绑定这个卡号
                bindErr = 'บัญชีธนาคารที่คุณเพิ่ม \n มีการใช้งานแล้วกับยูสเซอร์เนมอื่น'
            } else {
                webPiwikUrl("express_deposit_system_error_popup", "Express Deposit System Error Popup")
                bindErr = 'ไม่สามารถทำรายการได้ในขณะนี้ กรุณาลองใหม่ภายหลัง'
            }
        }

        if(!isSuccess && result.code) {
            webPiwikUrl("express_deposit_error_popup", "Express Deposit Error Popup")
            //联系客服处理
            bindErr = `การผูกบัญชีล้มเหลว \n กรุณาติดต่อฝ่ายบริการเพื่อให้ความช่วยเหลือ`
            onlyOkBtn = false
        }
        //是否已绑定
        const isReverseDeposit = (DepositMemberBanks.find((v) => { return v.isReverseDeposit == true })) || false
        return (
            <>
                <Modal
                    modalVisible={Boolean(bindErr)}
                    msg={bindErr}
                    onlyOkBtn={onlyOkBtn}
                    onChange={() => {
                        SetReverseBankDefault('')
                        LivechatClick()
                    }}
                    onCancel={() => {
                        webPiwikUrl("deposit_rd", "RD Deposit Page")
                        SetReverseBankDefault('')
                    }}
                />
                {
                    //没有收款银行卡
                    BanksBankAccounts.length == 0 &&
                    <>
                        <BankNone LivechatClick={LivechatClick} methods={'RD'} />
                    </>
                }
                {
                    //未绑定和没有用户银行卡
                    !isReverseDeposit && BanksBankAccounts.length > 0 && (
                        DepositMemberBanks.length == 0 ?
                        <AddBank
                            AddBankClick={() => {
                                webPiwikEvent("Deposit", "Add New Bank Account", `Deposit_LBExpress_C_Add_Bank`)
                                goAddBankInfo((data = '') => { GetDepositMemberBanks(data) }, 'RD')
                            }}
                        />
                        :
                        <BindBank
                            LivechatClick={LivechatClick}
                            onChange={() => {
                                webPiwikEvent("Deposit", "View Bank LBExpress", `Deposit_LBExpress_C_ViewBank`)
                                SetReverseBankDefault(DepositMemberBanksActive.code || '')
                            }}
                        />
                    )
                }

                {
                    //已绑定
                    isReverseDeposit && BanksBankAccounts.length > 0 &&
                    <BankActive
                        LivechatClick={LivechatClick}
                        DepositBankActive={BanksBankAccounts[0]}
                        setting={setting || {}}
                        isShowCS={isShowCS}
                    />
                }

            </>
        );
    }
}

const mapStateToProps = state => ({
    DepositMemberBanks: state.DepositMemberBanks,
    DepositMemberBanksActive: state.DepositMemberBanksActive,
    MethodsDetails: state.MethodsDetails,
    ReverseBankDefault: state.ReverseBankDefault,
    MemberInfo: state.MemberInfo,
    BanksBankAccounts: state.BanksBankAccounts,
});
const mapDispatchToProps = {
    SetDepositPayments_BQR: (data = {}) => SetDepositPayments_BQR(data),
    SetReverseBankDefault: (data) => SetReverseBankDefault(data),
    GetDepositMemberBanks: (data) => GetDepositMemberBanks(data),
};
export default connect(mapStateToProps, mapDispatchToProps)(RD);


